import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from "../../../auth/service";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { FormBuilder } from "@angular/forms";
import { Subscription } from "rxjs";
import { Theme } from "../../../../@core/types/app/theme";
import { ApplicationService } from "../../../../@core/services/application.service";
import { AnalyticsService } from "../../../services/analytics.service";

@Component({
  selector: 'app-business-selection',
  templateUrl: './business-selection.component.html',
  styleUrls: ['./business-selection.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BusinessSelectionComponent implements OnInit, OnDestroy {

  @Input() user: any;
  businessItems: any[];
  businessesSubscription: Subscription;
  searchQuery: string = '';
  placeholderText: string = 'Cerca...';
  private currentUser: any;
  public coreConfig: any;
  public tmpBusinessItems: any[];

  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _authenticationService: AuthenticationService,
    private _applicationService: ApplicationService,
    private router: Router,
    private analyticsService: AnalyticsService // Inject AnalyticsService
  ) {
    this._coreConfigService.config = {
      layout: {
        navbar: { hidden: true },
        menu: { hidden: true },
        footer: { hidden: true },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  ngOnInit() {
    this.analyticsService.trackEvent('business_selection_viewed', 'Viewed business selection', 'view');

    this.businessesSubscription = this._authenticationService.businesses$.subscribe(
      (businesses) => {
        this.businessItems = businesses;
        this.tmpBusinessItems = businesses;
      },
      (error) => {
        console.error('Error fetching businesses:', error);
      }
    );
    this._applicationService.getTheme().then((themeObservable) => {
      themeObservable.subscribe((theme: Theme) => {
        this.coreConfig = theme;
      });
    });
  }

  signOut() {
    this.analyticsService.trackEvent('sign_out', 'User signed out', 'authentication');
    this._authenticationService.signout();
  }

  identifyUserWithBusinessCode(code: string) {
    const eventDetails = `Identify user with business code: ${code}`;
    this.analyticsService.trackEvent('identify_user_with_business_code', eventDetails, 'identification');
    this._authenticationService.postBusinessCode(code)
      .catch((error) => {
        console.error('Error identifying user:', error);
      });
    this._authenticationService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  onSearch(event: any) {
    const eventDetails = `Business search query: ${event.target.value}`;
    this.analyticsService.trackEvent('business_search', eventDetails, 'search');
    this.businessItems = this.tmpBusinessItems;
    const inputValue = event.target.value as string;
    this.searchQuery = inputValue;
    this.businessItems = this.businessItems.filter((item) => {
      return item.name.toLowerCase().includes(inputValue.toLowerCase());
    });
  }

  clearSearch() {
    this.searchQuery = '';
    this.businessItems = this.tmpBusinessItems;
    this.placeholderText = 'Cerca...';
  }

  businessRegister() {
    this.analyticsService.trackEvent('navigate_to_business_register', 'Navigated to business registration', 'navigation');
    this.router.navigate(['/authentication/business-registration']);
  }

  ngOnDestroy() {
    this.businessesSubscription.unsubscribe();
  }
}
